import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-subproject-hierarchy-limit-modal',
  templateUrl: './subproject-hierarchy-limit-modal.component.html',
  styleUrls: ['./subproject-hierarchy-limit-modal.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubprojectHierarchyLimitModalComponent {

  // eslint-disable-next-line no-empty-function
  constructor(public dialogRef: MatDialogRef<SubprojectHierarchyLimitModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) { }
}
